import URLConfig from '@Config/urls/url.config';
import { LinkItemProps } from '@Layouts/sidebar/AppSidebar';

const URL = URLConfig.CARD_MANAGEMENT_SYSTEM.CARDHOLDER.CARD_PERSONALIZATION_MENU;

const CardPersonalizationMenuLink: Array<LinkItemProps> = [
  {
    name: 'Consultation personalisation incomplete',
    link: URL.INCOMPLETE_PERSONALIZATION_CONSULTATION,
    level: 3,
  },
  {
    name: 'Validation pre-personalisation',
    link: URL.PRE_PERSONALIZATION_VALIDATION,
    level: 3,
  },
  {
    name: 'Envoi lot de personalisation',
    link: URL.SENDING_PERSONALIZATION_BATCH,
    level: 3,
  },
  {
    name: 'Retour lot de personalisation',
    link: URL.RETURN_PERSONALIZATION_BATCH,
    level: 3,
  },
  
];

export default CardPersonalizationMenuLink;
